var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaintenanceLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6031 32.8594L82.7656 41.6969C80.3344 44.1344 76.3594 44.1375 73.9281 41.7C71.4906 39.2625 71.4906 35.2969 73.925 32.8594L82.7656 24.0219L73.9281 15.1844L65.0844 24.0219C59.3344 29.775 58.1813 38.3406 61.4844 45.3063L20.8969 85.8906L29.7344 94.7281L70.3219 54.1406C72.8594 55.3438 75.5906 56.0188 78.3438 56.0188C83.1469 56.0188 87.9469 54.1906 91.6031 50.5375L100.441 41.6969L91.6031 32.8594Z",
    fill: "#000433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1612 66.1331L58.3237 74.9731L74.7949 91.4395L83.6324 82.5995L67.1612 66.1331Z",
    fill: "#FC3165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3236 35.2872L27.4757 51.135L36.3145 59.9738L52.1623 44.1259L43.3236 35.2872Z",
    fill: "#FC3165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4517 10.4237L2.61295 19.2624L26.5593 43.2088L35.3981 34.3701L11.4517 10.4237Z",
    fill: "#000433"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaintenanceLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maintenance-light.b8f7f3d42a5001aa654a7e3259fdd8b9.svg";